/*** IMPORTS FROM imports-loader ***/
(function() {
var jquery = require("jquery");

// extracted by mini-css-extract-plugin
}.call(window));